import { useState } from "react";
import { loadEmployeeAttendanceMonthWise } from "../services/humanResourceServices";

const useHRMonthWiseEmployeeAttendance = () => {

    const [attendanceList, setAttendanceList] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [loading, setLoading] = useState(true);  // Add loading state here  
    const [presentDays, setPresentDays] = useState(0);
    const [absentDays, setAbsentDays] = useState(0);
    const [halfDayLeaves, setHalfDayLeaves] = useState(0);
    const [hourPermissions, setHourPermissions] = useState(0);
    const [fullLeaveDays, setFullLeaveDays] = useState(0);
    const [holiDays, setHoliDays] = useState(0);
  

    // fetch monthly attendance
    const fetchMonthlyAttendance = async (payload) => {
        try {
            const data = await loadEmployeeAttendanceMonthWise(payload);
            if (data) {
                setAttendanceList(data);
                setPresentDays(data[0].present_days);
                setAbsentDays(data[0].absent_days);
                setHalfDayLeaves(data[0].half_day_leaves);
                setHourPermissions(data[0].hour_permissions);
                setFullLeaveDays(data[0].full_leave_days);
                setHoliDays(data[0].holiday_days);
                setIsDataLoaded(true);
            }
        } catch (error) {
            console.error(error.message);
        } finally {
            setLoading(false);  // Set loading to false after data is fetched
        }

    }

    const handleEmployeeMonthWiseAttendance = async (payload) => {
        await fetchMonthlyAttendance(payload);
    }

    return { attendanceList, setAttendanceList, isDataLoaded, setIsDataLoaded, loading, handleEmployeeMonthWiseAttendance, presentDays,absentDays,halfDayLeaves,hourPermissions,fullLeaveDays,holiDays };
};

export default useHRMonthWiseEmployeeAttendance;